import React, {useCallback, useEffect, useMemo, useState} from 'react';
import UModal from 'ubs-framework/v2/UModal/NewUModal';
import UAvatar from "ubs-framework/v2/UAvatar";
import useUAlert from "ubs-framework/v2/UAlert";
import * as Icon from "ubs-icons";
import {FILE, REGEX} from "ubs-framework/v2/common/constant";
import {useSelector} from "react-redux";
import {useDropzone} from "react-dropzone";

import {api2, sendData} from "../../../../store/actions";
import useSocket from "../../hooks/useSocket";
import VerifyTableData from "./common/verify-data-table";
import UploadFile from "./common/upload-file";
import SuccessDataTable from "./common/success-data-table";
import {getCookie} from "ubs-framework/v2/common/function";
import {Encryption, isThisAFile, showToastSuccess} from "ubs-framework/v2/common/function";
import {getKeyValue, getLabelValue, getLabelValueUserImage, getThumbor} from "ubs-framework/v2/common/function";
import Select, {components} from "react-select";
import UInput from "ubs-framework/v2/UInput";
import UButton from "ubs-framework/v2/UButton";
import ViewRemark from "./common/view-remark";

let arr = []

const BulkResumeImportExport = React.memo(({open, header, onClose,}) => {
    const alert = useUAlert()
    const _ORG_ID = useSelector(e => e.common.orgId);
    const _S3_BASE_URL = useSelector(e => e.common.S3_BASE_URL);

    const _SOCKET_ID = useSelector(e => e.common.socketId);
    const _FSL = useSelector(e => e.common?.settings?.maxFileSizeLimit);
    const _SL_LV = useSelector(e => getLabelValue(e?.hrms?.sourceList));
    const _A_LT_KV = useSelector(e => getKeyValue(e?.hrms?.branchList));
    const _A_JTL_KV = useSelector(e => getKeyValue(e?.hrms?.jobTitleList));
    const _CI = useSelector(e => e?.ats?.generalSetting?.candidateIdType);

    const [file, setFile] = useState('');
    const [finalData, SetFinalData] = useState({});
    const [isMulti, setIsMulti] = useState([]);
    const [loader, setLoader] = useState(false);
    const [ie, setIe] = useState({
        listOpen: false,
        done: 0,
        randomString: '',
        errorList: [],
        successData: [],
        alreadyRegistered: [],
        headers: [],
        HEADER: []
    });
    const [jobList, setJobList] = useState([]);
    const [updatedFields, setUpdatedFields] = useState([]);
    const [globalErrorList, setGlobalErrorList] = useState([]);
    const [step1ErrorFlag, setStep1ErrorFlag] = useState(true);
    const [buttonLoader, setButtonLoader] = useState(false);
    const [showFinishedMessage, setShowFinishedMessage] = useState(false);
    const [activeTab, setActiveTab] = useState('error');
    const [selectedJob, setSelectedJob] = useState({});
    /** error/ success */
    const [files, setFiles] = useState([])
    const [uploadedResumeForParse, setUploadedResumeForParse] = useState({})

    const [isLoading, setIsLoading] = useState(false);
    const [employeeListOption, setEmployeeListOption] = useState([]);
    const [parsedResumeData, setParsedResumeData] = useState([]);
    const [allValues, setAllValues] = useState({
        job: null,
    })
    const [getRemark, setGetRemark] = useState(null);

    useEffect(() => {
        refresh()
        return () => off();
    }, [ie, selectedJob, finalData])

    const {on, off, refresh} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'uploadedResumeForParse':
                    if (res.data) {
                        setUploadedResumeForParse(prevState => ({
                            ...prevState, [res?.data?.randomId]: res?.data
                        }))
                    }
                    break;
                case 'uploadedResumeInfo':
                    if (res.data) {
                        /**
                         * finalData[res?.data?.randomId] condition for remove deleted rows in parse resume data
                         * */
                        if (finalData[res?.data?.randomId]) {
                            setUploadedResumeForParse(prevState => ({
                                ...prevState, [res?.data?.randomId]: {
                                    ...res?.data,
                                    validate: res?.data?.validate || {},
                                    contactNoErr: res?.data?.validate?.contactNoErr || '',
                                    emailErr: res?.data?.validate?.emailErr || '',
                                }
                            }))

                            setIe({
                                ...ie,
                                step: 2,
                                uploadedFile: prevState => ({
                                    ...prevState, [res?.data?.randomId]: {
                                        ...res?.data,
                                        validate: res?.data?.validate || {},
                                        contactNoErr: res?.data?.validate?.contactNoErr || '',
                                        emailErr: res?.data?.validate?.emailErr || '',
                                    }
                                }),
                            })
                        }
                    }
                    break;
                case 'ats|candidate|validate':
                    setUploadedResumeForParse(prevState => (
                        {
                            ...prevState,
                            [res?.data?.randomId]: {
                                ...prevState[res?.data?.randomId],
                                validate: {candidate: res?.data?.candidate, isExists: res?.data?.isExists, isCandidateIdExists: res?.data?.isCandidateIdExists},
                                contactNoErr: res?.data?.contactNoErr || '',
                                emailErr: res?.data?.emailErr || '',
                            }
                        }
                    ))
                    setIe({
                        ...ie,
                        step: 2,
                        uploadedFile: prevState => ({
                            ...prevState,
                            [res?.data?.randomId]: {
                                ...prevState[res?.data?.randomId],
                                validate: {candidate: res?.data?.candidate, isExists: res?.data?.isExists, isCandidateIdExists: res?.data?.isCandidateIdExists},
                                contactNoErr: res?.data?.contactNoErr || '',
                                emailErr: res?.data?.emailErr || '',
                            }
                        }),
                    })
                    break;
                case 'ats|candidate|resumeAdd':
                    setButtonLoader(false)
                    setShowFinishedMessage(true)
                    setParsedResumeData(res?.data?.result)
                    setIsMulti([])
                    showToastSuccess('Resume Parsing successfully.');
                    break;
                case 'ats|job|search':
                    setEmployeeListOption(getLabelValueUserImage(res?.data?.list?.filter(_ => _?.applicationField?.fields)));
                    if (res?.data?.list?.length) {
                        setAllValues({
                            ...allValues, job: {
                                label: res?.data?.list[0]?.name,
                                value: res?.data?.list[0]?._id
                            }
                        });
                    }
                    setIsLoading(false);
                    break;
                case 'ats|candidate|getRemark':
                    if (res?.data?.randomId) {
                        const cloneObj = JSON.parse(JSON.stringify(uploadedResumeForParse));
                        if (cloneObj[res?.data?.randomId]) {
                            cloneObj[res?.data?.randomId] = {
                                ...cloneObj[res?.data?.randomId],
                                data: {...cloneObj[res?.data?.randomId]?.data, remarkCount: res?.data?.getRemarks?.length ?? 0}
                            }
                        }
                        setUploadedResumeForParse(e => ({...e, ...cloneObj}));
                    }
                    break;
                default:
                    return true;
            }
        } else {
            switch (res.code) {
                case 400:
                case 412:
                case 500:
                    setButtonLoader(false)
                    break;
                default:
                    return true;
            }
        }
    });

    const onDrop = useCallback(acceptedFiles => {
        if (FILE.DOCS.exec(acceptedFiles[0]?.name) || FILE.IMAGES.exec(acceptedFiles[0]?.name)) {
            let sizeError = false;
            sizeError = acceptedFiles[0].size / 1024 / 1024 > 10;
            if (!sizeError) {
                setFile(acceptedFiles)
                prepareFiles(acceptedFiles);
            } else {
                alert.show({title: 'Something went wrong.', description: `Files must smaller than 10 MB!`})
            }
        } else {
            alert.show({title: 'Something went wrong.', description: 'Unsupported File.'})
        }
    }, [selectedJob, allValues]);

    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        onDrop,
        multiple: true,
        accept: 'image/jpg, image/jpeg, image/png, .pdf, .doc, .docx, .rtf'
    });

    const prepareFiles = async (data) => {
        let sizeError = false;
        const fileArray = Object.assign([], data);
        for (let i = 0; i < fileArray.length; i++) {
            if (!sizeError) sizeError = fileArray[i].size / 1024 / 1024 > _FSL;
        }

        if (!sizeError) {
            let myFiles = [];
            const number = data.length;
            for (let i = 0; i < number; i++) {
                const name = fileArray[i]?.name?.split('.');
                const ext = name[name.length - 1];
                if (FILE.DOCS.exec(fileArray[i]?.name) || FILE.IMAGES.exec(fileArray[i]?.name)) {
                    if (!FILE.EXCLUDES.includes(ext)) {
                        await isThisAFile(fileArray[i]).then(validFile => {
                            myFiles.push(validFile);
                        }).catch(error => {
                        });
                    }
                } else {
                    alert.show({title: 'Something went wrong.', description: 'Unsupported File.'})
                }
            }
            setFiles(myFiles)
            uploadCSV(myFiles)
        } else {
            setFile(null);
            alert.show({title: 'Something went wrong.', description: `Files must smaller than ${_FL}MB!`})
        }
    };

    const uploadCSV = (files) => {
        if (files?.length <= 50) {
            if (!loader) {
                setLoader(true)
                const file = {};
                const fileFormData = [], viewFile = {};
                /** viewFile Object for preview selected file on step 2(Preview Data) */
                for (let i = 0; i < files.length; i++) {
                    const rId = Math.random().toString(36).substr(2, 9).toString();
                    const f = files[i];
                    file[rId] = {size: f.size, fileName: f.name, mimeType: f.type, lastModified: f.lastModified};
                    fileFormData.push({key: rId, file: f});
                    viewFile[rId] = f
                }

                const body = {
                    event: 'uploadResumeFiles',
                    data: {
                        payload: file,
                        isBulkUpload: true,
                        orgId: _ORG_ID,
                        job: selectedJob?.value
                    },
                    socketId: _SOCKET_ID
                };

                const formData = new FormData();
                formData.append('body', Encryption(body));
                fileFormData.forEach(e => {
                    formData.append(e.key, e.file);
                });

                const config = {
                    headers: {'Authorization': `Bearer ${getCookie('ubs_token')}`},
                    onUploadProgress: e => {
                    },
                };

                setIe({
                    ...ie,
                    step: 2,
                    uploadedFile: viewFile
                })
                setButtonLoader(false)

                api2.post('/resume/upload', formData, config).then(res => { //fileUpload , hrmsFileUpload
                    setLoader(false)
                    if (res?.data?.data?.statusCode === 500) {
                        alert.show({title: 'Something went wrong.', description: res?.data?.data?.error})
                    }
                    if (res?.data) {

                    }
                }).catch(error => {
                    setLoader(false)
                })
            }
        } else {
            setFile(null);
            alert.show({title: 'Something went wrong.', description: 'You can only upload 50 files at a time.'})
        }
    }

    const onDragEnter = (event) => {
        if (event.target.className === "u_org-dashboard" || "u_upload-file-inner") {
            // event.target.style.border = "3px dotted red";
        }
    }

    const dragLeave = (event) => {
        if (event.target.className === "u_org-dashboard" || "u_upload-file-inner") {
            event.target.style.border = "";
        }
    }

    const handle = {
        select: (e, key) => {
            if (key === 'job') {
                if (e?._id) sendData('ats|job|fetch', {_id: e?._id})
            }
            setAllValues({...allValues, [key]: e ?? null})
        },
        change: (e, key) => {
            let data = JSON.parse(JSON.stringify(updatedFields))
            data = data?.map((d, i) => {
                if (key === d?.fileKey) d = {...d, mainKey: e?.value, isRequired: e?.isRequired}
                return d
            })
            setUpdatedFields(data);
            let index = data?.findIndex(_ => _?.mainKey === '')
            setStep1ErrorFlag(index !== -1)
        },
        matchData: e => {
            let resumeArr = []
            if (Object.keys(finalData)?.length) {

                Object.keys(finalData)?.map((resumeData, i) => {
                    if (finalData[resumeData]?.data?.firstName || finalData[resumeData]?.data?.email || finalData[resumeData]?.data?.contactNo) {
                        if (REGEX.EMAIL.test(finalData[resumeData]?.data?.email)) {
                            /**
                             * check email is valid or not
                             * */
                            resumeArr.push({
                                job: finalData[resumeData]?.data?.job?._id || selectedJob?.value,
                                firstName: finalData[resumeData]?.data?.firstName || '',
                                lastName: finalData[resumeData]?.data?.lastName || '',
                                contactNo: finalData[resumeData]?.data?.contactNo || '',
                                email: finalData[resumeData]?.data?.email || '',
                                skill: finalData[resumeData]?.data?.skill?.map((_) => _?.value || _) || [],
                                tags: finalData[resumeData]?.data?.tags?.map((_) => _?.value || _) || [],
                                fileId: finalData[resumeData]?.fileId || '',
                                randomId: finalData[resumeData]?.randomId || '',
                                ...(finalData[resumeData]?.data?.candidateId && {candidateId: finalData[resumeData]?.data?.candidateId}),
                                ...(finalData[resumeData]?.data?.isReplace && {isReplace: finalData[resumeData]?.data?.isReplace}),
                                ...(finalData[resumeData]?.data?._id && {_id: finalData[resumeData]?.data?._id}),
                            })
                        }
                    }
                })
            }
            if (resumeArr?.length) {
                setButtonLoader(true)
                sendData('ats|candidate|resumeAdd', {resumeData: resumeArr});
            }
        },
        addCandidate: e => {
            let resumeArr = []
            if (isMulti?.length) {
                isMulti?.map((resumeData, i) => {
                    if (resumeData?.data?.email || resumeData?.data?.contactNo) {
                        if (REGEX.EMAIL.test(resumeData?.data?.email)) {
                            /**
                             * check email is valid or not
                             * */
                            resumeArr.push({
                                job: allValues?.job?.value,
                                firstName: resumeData?.data?.firstName || '',
                                lastName: resumeData?.data?.lastName || '',
                                contactNo: resumeData?.data?.contactNo || '',
                                email: resumeData?.data?.email || '',
                                skill: resumeData?.data?.skill?.map((_) => _?.value || _) || [],
                                tags: resumeData?.data?.tags?.map((_) => _?.value || _) || [],
                                fileId: resumeData?.fileId || '',
                                randomId: resumeData?.randomId || '',
                            })
                        }
                    }
                })
            }
            if (isMulti?.length) {
                setButtonLoader(true)
                sendData('ats|candidate|resumeAdd', {resumeData: resumeArr});
            }
        }
    }

    const searchEmployee = value => {
        setAllValues({...allValues, searchEmpText: value});
        if (value?.length) setIsLoading(true);
    }

    const visibleContinueButton = useMemo(() => {
        let flag = true
        Object.keys(finalData)?.map((randomId, i) => {
            if (finalData[randomId]?.data?.['email'] !== undefined && REGEX.EMAIL.test(finalData[randomId]?.data?.['email']) && finalData[randomId]?.data?.['firstName'] !== undefined && (finalData[randomId]?.data?.['candidateId'] !== undefined || _CI === 2 || selectedJob?.candidateIdStatus === 2) && !finalData[randomId].validate.isExists) {

            } else {
                flag = false
            }
        })
        return flag
    }, [finalData, _CI, selectedJob])

    useEffect(() => {
        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);

    const handleBeforeUnload = (e) => {
        e.preventDefault();
        const message = "Are you sure you want to leave? All provided data will be lost.";
        e.returnValue = message;
        return message;
    };


    return (
        <React.Fragment>
            {open &&
            <UModal
                open={open}
                maxWidth={`calc(100% - 90px)`}
                className="u_import-sidemodal"
                onClose={onClose}
                confirmationOnClose
                header={<h4>{header}</h4>}
                position="right"
                confirmationTitle="Something went wrong."
                confirmationDescription={`Are you sure want to close Import Resume Upload?`}
            >
                <React.Fragment>
                    <div className="u_common-import">
                        <div className={`u_import-step u_p-20 u_border-bottom ${ie?.step === 1 ? 'u_pb-20' : ''}`}>
                            <div className="u_flex u_align-center u_content-between">

                                <ul className="u_flex u_policy-header-timeline">
                                    <li className={`u_text-center u_relative ${(!ie?.step || ie?.step === 1 || ie?.step === 2 || ie?.step === 3) ? 'u_policy-select' : ''}`}>
                                        <span className="u_flex u_align-center u_content-center u_relative u_round-radius u_m-auto u_cp">1</span>
                                        <p>Import Sheet</p>
                                    </li>
                                    <li className={`u_text-center u_relative ${(ie?.step === 2 || ie?.step === 3) ? 'u_policy-select' : ''}`}>
                                        <span className="u_flex u_align-center u_content-center u_relative u_round-radius u_m-auto u_cp">2</span>
                                        <p>Save Data</p>
                                    </li>
                                </ul>

                                <div className="u_common-import-btn">
                                    {/*{isMulti?.length !== 0 || (ie?.step && ie?.step !== 3 && visibleContinueButton) && parsedResumeData?.length !== Object.keys(finalData)?.length &&*/}
                                    {(ie?.step && ie?.step !== 3 && visibleContinueButton) && parsedResumeData?.length !== Object.keys(finalData)?.length &&
                                    <button
                                        type="submit"
                                        className={`u_btn u_btn__smallBtn u_btn__blue`}
                                        // disabled={step1ErrorFlag || buttonLoader}
                                        onClick={() => handle.matchData()}>Continue
                                    </button>}

                                    {buttonLoader && <div className="u_flex u_content-end"><Icon.Preloader size={40}/></div>}
                                    {showFinishedMessage && <h4>Resume Imported Finished</h4>}
                                </div>
                            </div>
                            <p className="u_small-font u_task-darkname u_mt-15">Note: You can upload Max 50 Resumes at a time.</p>
                        </div>

                        {!!isMulti?.length && <div className="u_flex u_align-center u_p-15">
                            <div>
                                <UInput label="Select Job" select selectValue={allValues?.job}>
                                    <Select
                                        name="job"
                                        className="u_label-input-select-inner"
                                        classNamePrefix="u_select"
                                        placeholder=" "
                                        isClearable={false}
                                        value={allValues?.job ?? null}
                                        onInputChange={searchEmployee}
                                        onChange={e => handle.select(e, 'job')}
                                        options={employeeListOption}
                                        noOptionsMessage={() => allValues?.searchEmpText?.length < 3 ? 'Type three character to search job name.' : isLoading ? 'Loading...' : 'No Record Found'}
                                        menuPosition="fixed"
                                        filterOption={options => options}
                                        onKeyDown={e => {
                                            if ((e.keyCode === 32 || e.keyCode === 8 || e.keyCode === 9) && !e.target.value) e.preventDefault();
                                        }}
                                        components={{
                                            Option: (props) => (
                                                <components.Option {...props}>
                                                    <div className="u_filter-employee-info">
                                                        <UAvatar name={props?.data?.label} width={24} thumbor={getThumbor('32x32')}
                                                                 image={props?.data?.profileImage} s3Url={_S3_BASE_URL}/>
                                                        <p className="u_one-line">{props?.data?.label}</p>
                                                    </div>
                                                </components.Option>
                                            ),
                                            SingleValue: (props) => (
                                                <components.SingleValue {...props}>
                                                    <div className="u_filter-employee-info">
                                                        <UAvatar name={props?.data?.label} width={24} thumbor={getThumbor('32x32')}
                                                                 image={props?.data?.profileImage} s3Url={_S3_BASE_URL}/>
                                                        <p className="u_one-line">{props?.data?.label}</p>
                                                    </div>
                                                </components.SingleValue>
                                            ),
                                        }}
                                    />
                                </UInput>
                            </div>

                            <div className="u_inline-flex u_ml-10" style={{width: '120px'}}>
                                <UButton disabled={loader} loading={loader} isSubmit variant="blue" type="Save" cn="" onClick={handle.addCandidate}/>
                            </div>
                        </div>}

                        {/** steppers for step 2 & 3 */}
                        {/*{ie?.step === 2 && <div className="u_route-tabs u_bb-light" id="u_route-tabs">
                            <ul className="u_flex u_align-center">
                                <li onClick={() => setActiveTab('error')}>
                                    <a className={`${activeTab === 'error' ? 'active' : ''}`}>Error
                                        {!!finalData?.length && <div className="u_badge u_ml-3">
                                            <label className="u_badge-inner">{finalData?.length}</label>
                                        </div>}
                                    </a>
                                </li>
                                <li onClick={() => setActiveTab('success')}>
                                    <a className={`${activeTab === 'success' ? 'active' : ''}`}>Success
                                        {!!ie?.successData?.length && <div className="u_badge u_ml-3">
                                            <label className="u_badge-inner">{ie?.successData?.length}</label>
                                        </div>}
                                    </a>
                                </li>
                            </ul>
                        </div>}*/}

                        {![1, 2, 3].includes(ie?.step) && <UploadFile
                            dragLeave={(e) => dragLeave(e)}
                            onDragEnter={(e) => onDragEnter(e)}
                            getInputProps={getInputProps}
                            getRootProps={getRootProps}
                            file={file}
                            loader={loader}
                            selectedJob={selectedJob}
                            setSelectedJob={setSelectedJob}

                        />}

                        {(ie?.step === 2 && activeTab === 'error') && <VerifyTableData
                            errorList={ie?.errorList}
                            originalErrorList={ie?.errorList}
                            globalErrorList={globalErrorList}
                            randomString={ie?.randomString}
                            FinalData={(e) => SetFinalData(e)}
                            setGlobalErrorList={(e) => setGlobalErrorList(e)}
                            activeTab={activeTab}
                            setGetRemark={setGetRemark}
                            setIsMulti={(e) => setIsMulti(e)}
                            uploadedFile={ie.uploadedFile || []}
                            selectedJob={selectedJob}
                            uploadedResumeForParse={uploadedResumeForParse}
                            parsedResumeData={parsedResumeData}
                            setUploadedResumeForParse={(e) => setUploadedResumeForParse(e)}
                        />}

                        {((ie?.step === 2 && activeTab === 'success') || ie?.step === 3) && <SuccessDataTable
                            successData={ie?.successData}
                        />}

                    </div>
                </React.Fragment>
            </UModal>
            }
            {getRemark && <ViewRemark getRemark={getRemark} onClose={() => setGetRemark(null)}/>}

        </React.Fragment>
    );
});

export default BulkResumeImportExport;
